import { render, staticRenderFns } from "./LoadoutSlots.vue?vue&type=template&id=53904839&scoped=true&"
import script from "./LoadoutSlots.vue?vue&type=script&lang=ts&"
export * from "./LoadoutSlots.vue?vue&type=script&lang=ts&"
import style0 from "./LoadoutSlots.vue?vue&type=style&index=0&id=53904839&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53904839",
  null
  
)

export default component.exports